import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'cockehsu-help',
  templateUrl: 'cockehsu-help.component.html',
  styleUrls: ['cockehsu-help.component.css']
})
export class CockehsuHelpComponent {

  @Output() private dialogClose = new EventEmitter<boolean>();

  constructor() { }

  private close() {
    this.dialogClose.emit(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/cockehsu-help.component.ts